import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

import Home from '../Modules/Home/Home';
import Login from '../Modules/Authentication/Login';
import Listing from '../Modules/Listing/Listing';
import Dataview from '../Modules/Dataview/Dataview';

import AuthHome from '../Modules/AuthHome/AuthHome';
import AuthListing from '../Modules/AuthListing/AuthListing';
import Userview from '../Modules/Userview/Userview';

class Router extends React.Component {
    constructor() {
        super()
        this.state = {
            isAuthenticated: false
        }
    }

    verifyToken = () => {
        //pass cookie with JWT token to API

        //wait for api to return true or false
    }

    render() {
        // const isAuthenticated = this.verifyToken()
        return (
            // isAuthenticated
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={Home}></Route>
                    <Route exact path="/Login" component={Login}></Route>
                    <Route exact path="/Listing" component={Listing}></Route>

                    {/* Routes below needs to be Authenticated */}

                    <PrivateRoute exact path="/Home" component={AuthHome}></PrivateRoute>
                    <PrivateRoute exact path="/Authed/Listing" component={AuthListing}></PrivateRoute>
                    <PrivateRoute exact path="/Dataview" component={Dataview}></PrivateRoute>
                    <PrivateRoute exact path="/Userview" component={Userview}></PrivateRoute>
                </Switch>
            </BrowserRouter>
        )
    }
}

export default Router;